import { Link } from "react-router-dom";
import PageShell from "@/components/feature/PageShell";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("页面未找到 - 濑户环奈官网");

  return (
    <PageShell>
      <div className="w-full px-4 md:px-8 py-24 md:py-32">
        <div className="max-w-2xl mx-auto flex flex-col items-center text-center">
          <span className="font-heading text-7xl md:text-9xl font-bold text-primary-200 select-none">
            404
          </span>
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-6 mb-3">
            页面走丢了
          </h1>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            你访问的页面不存在或已被移除，不如先回到首页看看濑户环奈的最新作品与动态。
          </p>
          <div className="flex items-center gap-3 flex-wrap justify-center">
            <Link
              to="/"
              className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              返回首页
            </Link>
            <Link
              to="/works"
              className="px-6 py-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览影视作品
            </Link>
          </div>
        </div>
      </div>
    </PageShell>
  );
}